// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2yqCY","list":"BalanceDue_list__uvlXU","listRow":"BalanceDue_listRow__1BW6M","total":"BalanceDue_total__rN8IT"};